const AD_TRACTION_URL = "https://go.telia.se/jsTag?ap=1960510142";

const init = (url) => {
  const head = document.getElementsByTagName("head")[0];
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.setAttribute("defer", "defer");
  script.src = url;
  head.appendChild(script);
};
const purchaseEvent = (orderId, tp) => {
  try {
    const ADT = window.ADT || {};
    ADT.Tag = ADT.Tag || {};
    ADT.Tag.t = 3;
    ADT.Tag.c = "SEK";
    ADT.Tag.tp = tp;
    ADT.Tag.ti = `${orderId}`;
    window.ADT?.Tag?.doEvent?.();
  } catch (e) {
    console.warn("AdTraction error:", e);
  }
};
const inject = () => {
  init(AD_TRACTION_URL);
};

export { inject, purchaseEvent };
//# sourceMappingURL=b2x-adtraction.esm.js.map
